import React from 'react';
import moment from 'moment';
import {Link, browserHistory} from 'react-router';

class MessageThread extends React.Component{

  constructor(props){
    super(props)
    this.formatDate = this.formatDate.bind(this);
  }

  formatDate(timestamp){
    return moment(timestamp).fromNow();
  }

  // routeToChat = (link) => {
  //   browserHistory.push(link);
  // }

  render(){
    let {props} = this;
    const self = this;
    let {message} = props;
    let messageClass;
    let messageLastSeen = this.formatDate(message.created);

    (!message.isRead) ? (messageClass = 'active-thread') : (messageClass = 'inactive-thread');

    let url = '/user-profile/' + props.message.carrierId;
    let userId = props.message.carrierId;
    let isVerified = props.message.isVerified;

    let messageDetailLink;
    if(message.isReceiver && message.receiverId){
      messageDetailLink = "/inbox-chat/" + message.shipmentId + "/" + message.carrierId + "?receiverId=" + message.receiverId + "&backTo=" + props.agentType;
    }
    else messageDetailLink = "/inbox-chat/"+ message.shipmentId + "/" + message.carrierId + "?backTo=" + props.agentType;

    return (
        <div className="message-component-wrap">
            <div className="wrapper">
              <Link to = {messageDetailLink}>
                <div className="message-component-elm">
                    <div className="user-details-wrp">
                        <div className="profile-image-wrp">
                          <img className="profile-image-elm" src={message.profileImgUrl || "../../public/images/user_placeholder.svg"}/>
                        </div>
                      <div className="profile-details-wrp">
                            <div className="profile-name">
                              <span className="profile-name-elm">{message.name}</span>
                              {isVerified && <span className="account-verified-elm"></span>}
                        </div>
                        <div className="product-detail">{message.title}</div>
                      </div>
                    </div>
                    <div className="user-messages-wrp">
                        {message.hasOwnProperty('isRead') && !message.isRead && <div className="unread-msg-indicator"></div>}
                        <div className={messageClass}>{message.message}</div>
                    </div>
                    <div className="message-last-seen">
                        {messageLastSeen}
                    </div>
                </div>
            </Link>
            </div>
        </div>
    )
  }
}

MessageThread.propTypes = {
  message: React.PropTypes.object.isRequired
}

module.exports = MessageThread;



// WEBPACK FOOTER //
// app/messages/message_thread_component.jsx